import React, { useState } from "react";
import {Helmet} from "react-helmet";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import guestimg from "./assets/guest.png";
//import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "./assets/logo.svg";
import close from "./assets/Close X.svg";
import "./Gueststyle.css";
import rentid from './assets/rentid.svg';
import { Link } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';
import GoogleSigninButton from "../ThirdPartySignIn/GoogleSigninButton";
const Guest = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [show, setShow] = useState(false);
  // Validation Schema
  const validationSchema = Yup.object({
    emailOrPhone: Yup.string()
      .required("Email or Phone number is required")
      .matches(
        /^(\+?[0-9]{7,15}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
        "Enter a valid email or phone number"
      ),
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters"),
  });

  // Initial Values
  const initialValues = {
    emailOrPhone: "",
    password: "",
  };

  // Submit Handler
  const onSubmit = (values) => {
    //console.log("Form Data", values);
    // Handle the login logic here
    setShow(true);
    setTimeout(() => setShow(false), 3000);
  };


  return (
    <div className="rent-idlogin guest-black-bg">
      <Helmet>
        <title>RentId | Guest Login</title>
        <meta property="og:title" content="RentId | Guest Login" />
        <meta name="twitter:title" content="RentId | Guest Login" />
        <meta name="description" content="RentId Guest Login" />
        <meta name="twitter:description" content="RentId Guest Login" />
        <meta property="og:description" content="RentId Guest Login" />
        <meta name="keywords" content="Car Rental Support, Refund Policies, Insurance, Cancellation, Support, Guest, Resource Center, Rental Empowerment, Guidelines" />
        <meta property="og:url" content="https://www.rentid.io/guest" />
        <link rel="canonical" href="https://www.rentid.io/guest" />
      </Helmet>
      <div className="container">
        <nav className="navbar">
          <a href="/" className="navbar-brand">
            <img
              src={logo}
              alt="Rentid Logo"
              className="d-inline-block align-text-top"
              style={{ height: "40px" }}
            />
          </a>
        </nav>
        <div className="row align-items-center login-host">
                <div className="col-md-6 position-relative host-banner">
        <img src={guestimg} alt="Guest Login" className="img-fluid" />
        <div className="position-absolute top-0 start-0 p-3 text-white">
          <img src={rentid} alt="Guest Vehicle Rentals" className="img-fluid mb-3" />
          <h2 className="img-head">Vehicles When You Want Them</h2>
        </div>
       <div className="position-absoulute text-center bottom-text-jorney">
        <p className="img-para">The perfect vehicle for your journey</p>
        </div>
      
      </div>

          {/* Login Form Section */}
          <div className="col-md-6">
            <div className="login-content-host">
              <h1>
               <Link to='/'> <img src={close} alt="Host" className="img-fluid" /></Link> Guest Account{" "} 
                <strong>Login</strong>
              </h1>
              <Alert transition={true} variant="danger" show={show} onClose={() => setShow(false)} dismissible>
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>
                  Your account was not found. Please check your email or phone number and try again.
                </p>
              </Alert>
              {/* Formik Form */}
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ errors, touched }) => (
                  <Form>
                    {/* Email/Phone Field */}
                    <div className="mb-4">
                      <label htmlFor="emailOrPhone" className="form-label">
                        Email or phone number
                      </label>
                      <Field
                        type="text"
                        id="emailOrPhone"
                        name="emailOrPhone"
                        className={`form-control ${
                          errors.emailOrPhone && touched.emailOrPhone
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter  email or phone number"
                      />
                      <ErrorMessage
                        name="emailOrPhone"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    {/* Password Field */}
                 <div className="mb-4">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <div className="input-group">
                  <Field
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    className={`form-control ${
                      errors.password && touched.password ? "is-invalid" : ""
                    }`}
                    placeholder="Enter password"
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary password-toggle pb-2"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                   <img
                              src='/img/view-off.svg'
                              alt="Logo"
                              className="d-inline-block align-text-top"
                              style={{ height: "40px" }}
                            />
                    {/* {showPassword ? <FaEyeSlash /> : <FaEye />} */}
                  </button>
                </div>
                <ErrorMessage
                  name="password"
                  component="div"
                  className="invalid-feedback"
                />
              </div>

                    {/* Forgot Password Link */}
                    <div className="mb-4 text-end">
                      <Link href="#" className="text-decoration-none">
                        Forgot Password?
                      </Link>
                    </div>

                    {/* Login Button */}
                    <button type="submit" className="btn btn-secondary w-100">
                      Login
                    </button>

                    <div className="col-lg-12 col-md-12">
                      <div className="or">
                        <span style={{backgroundColor: '#000000'}}>Or</span>
                      </div>
                    </div>

                    <div className="col-lg-12 col-md-12">
                      <div className="continueLogin">
                        <ul>
                          <li>
                            <GoogleSigninButton register={false} type="guest" />
                          </li>
                        </ul>
                      </div>
                    </div>




                    <div className="mb-4 mt-4 text-center">
                      <Link to="/guest-signup" className="signup-txt">
                        Don’t have an account? Sign up for rentid.
                      </Link>
                    </div>
                    <div className="mb-0 text-center">
                      <p>
                        By signing up, you agree to the{" "}
                        <Link to="/terms">Terms of Service</Link> &{" "}
                         <Link to="/privacy">Privacy Policy</Link>, including our{" "}
                        <a href="/cookie-policy">Cooking Policy</a>.{" "}Rentid {new Date().getFullYear()}
                      </p>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guest;
